var _rect, _rect2, _rect3, _rect4, _circle, _circle2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUz(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 250,
    fill: "#1eb53a"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 125,
    fill: "#0099b5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 90,
    y: 80,
    fill: "#ce1126"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 80,
    y: 85,
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 40,
    r: 30,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 40,
    r: 30,
    fill: "#0099b5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    transform: "translate(136,64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    id: "o",
    d: "M0,-6V0H3",
    transform: "rotate(18,0,-6)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#o",
    transform: "scale(-1,1)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t",
    transform: "rotate(72)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t",
    transform: "rotate(-72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    transform: "rotate(144)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    y: -24
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    y: -48
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s3",
    x: 24
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s3",
    x: 48
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    x: -48
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    x: -24
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    x: -24,
    y: -24
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUz);
export default __webpack_public_path__ + "static/media/uz.3591058cc0de313a8ab0197891a6a290.svg";
export { ForwardRef as ReactComponent };